import "./footer.css";

export function Footer({
  profile
}: {
  profile: { name: string; city?: string; email: string };
}) {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__left">
          <div className="footer__brand">{profile.name}</div>
          <div className="footer__meta">
            {profile.city ? <span>{profile.city}</span> : null}
            {profile.city ? (
              <span className="dot" aria-hidden>
                ·
              </span>
            ) : null}
            <a href={`mailto:${profile.email}`}>{profile.email}</a>
          </div>
        </div>
        <div className="footer__right">© {year} · Built with React + Vite</div>
      </div>
    </footer>
  );
}

